define(['modules/common/controls/input'], (Input) => Input.extend({

    tagName: 'textarea',
    attributes: {}

}));
